"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[78097],{

/***/ 762782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ProductVariants": function() { return /* binding */ ProductVariants; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(621655);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(534924);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(684443);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(634655);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var _UomItem__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(333818);







const OldProductVariantItem = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 481).then(__webpack_require__.bind(__webpack_require__, 500481)).then((mod)=>mod.ProductVariantItem), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(500481)
            ]
    }
});
const NewProductVariantItem = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 22311).then(__webpack_require__.bind(__webpack_require__, 22311)).then((mod)=>mod.ProductVariantItem), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(22311)
            ]
    }
});
const ProductVariants = ()=>{
    const { product , onSelectVariant  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useProductDetailState */ .W)();
    const { productOptions , clearanceTypeDescription , sku  } = product || {};
    const { fixedVariants , epicOmni1643 , isDisplayUom  } = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useTenantConfig */ .Wx)();
    const ProductVariantItem = epicOmni1643 ? NewProductVariantItem : OldProductVariantItem;
    // UX4BUYER-6250: hardcode variants for phongvu
    const variants = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        const orgVariants = productOptions === null || productOptions === void 0 ? void 0 : productOptions.rows;
        if (!orgVariants) return;
        if (!fixedVariants || !sku) return orgVariants;
        const fixedVariant = fixedVariants[sku];
        if (!fixedVariant) return orgVariants;
        return orgVariants.map((variant)=>{
            const fixedVariantOptions = fixedVariant[variant.title];
            if (fixedVariantOptions) {
                const options = fixedVariantOptions.map((opt)=>{
                    const existingOption = variant.options.find((option)=>option.label === opt.label);
                    return {
                        label: opt.label,
                        url: opt.url,
                        sku: opt.sku,
                        quantity: 1,
                        selected: !!existingOption
                    };
                });
                return {
                    title: variant.title,
                    options
                };
            } else {
                return variant;
            }
        });
    }, [
        fixedVariants,
        productOptions === null || productOptions === void 0 ? void 0 : productOptions.rows,
        sku
    ]);
    if (isDisplayUom && epicOmni1643 && (product === null || product === void 0 ? void 0 : product.uomName)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Flex */ .k, {
            direction: "column",
            backgroundColor: "white",
            gap: "s4",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Body */ .uT, {
                    level: 1,
                    color: "textPrimary",
                    children: [
                        (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Đơn vị t\xednh"),
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UomItem__WEBPACK_IMPORTED_MODULE_8__/* .UomItem */ .e, {})
            ]
        });
    }
    if (!(productOptions === null || productOptions === void 0 ? void 0 : productOptions.rows.length)) return null;
    return variants ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            variants.map((variant, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductVariantItem, {
                    variant: variant,
                    onSelect: onSelectVariant
                }, index)),
            !!clearanceTypeDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Caption */ .YS, {
                level: 1,
                color: "textSecondary",
                children: clearanceTypeDescription
            })
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {});
};


/***/ })

}]);